var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#00789E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#005F7C",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4998 41.75H33.5115M46.1073 29.1509C42.786 26.1073 38.3597 24.25 33.4997 24.25C28.6397 24.25 24.2134 26.1073 20.8921 29.1509M25.0204 33.2835C27.2816 31.2916 30.2496 30.0833 33.4998 30.0833C36.75 30.0833 39.7181 31.2916 41.9792 33.2835M37.8146 37.4043C36.6256 36.4723 35.1275 35.9167 33.4997 35.9167C31.8472 35.9167 30.3285 36.4893 29.1311 37.4468",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiSm);
export default __webpack_public_path__ + "static/media/wifi-sm.0a200f978c9555d897ba2ba145503255.svg";
export { ForwardRef as ReactComponent };